<template>
    <component :is="type" v-bind="linkProps(to,active)">
        <slot />
    </component>
</template>

<script>
import validate from "@/utils/validate";

export default {
    data() {
        return {
            active: "current",
        };
    },
    props: {
        to: {
            type: String,
            required: true,
        },
    },
    computed: {
        isExternal() {
            return validate.isExternal(this.to);
        },
        type() {
            if (this.isExternal) {
                return "a";
            }
            return "router-link";
        },
    },
    methods: {
        linkProps(to, active) {
            if (this.isExternal) {
                return {
                    href: to,
                    target: "_blank",
                    rel: "noopener",
                };
            }
            return {
                to: to,
                "exact-active-class": active ? active : "current",
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/common/link.vue